import { ReactNode } from 'react';
import styled from 'styled-components';

interface BadgeProps {
  content?: string | number | ReactNode;
}

const BadgeWrapper = styled.div`
  background: ${({ theme }) => theme.colors.alert_400};
  font-size: 9px;
  position: absolute;
  top: -8px;
  right: -8px;
  z-index: 10;
  min-width: 15px;
  height: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  padding-left: 2px;
  padding-right: 2px;
  color: white;
`;

const Badge = ({ content }: BadgeProps) => {
  return <BadgeWrapper>{content}</BadgeWrapper>;
};

export default Badge;
